import { FlightDropdownOption } from 'components/Flights/types'
import StructureLabel from 'LuxKit/Label/StructureLabel'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import React, { useCallback } from 'react'

interface Props extends Utils.PropsWithDataAttributes {
  selected: boolean
  option: FlightDropdownOption
  onOptionSelect: (option: FlightDropdownOption) => void
}

function FareDropdownOption(props: Props) {
  const { option, onOptionSelect, ...rest } = props

  const onSelect = useCallback(() => {
    onOptionSelect(option)
  }, [option, onOptionSelect])

  return (
    <ClickableListItem
      {...rest}
      title={option.label}
      key={option.value}
      onClick={onSelect}
      disabled={option.disabled}
    >
      {option.comingSoon && <StructureLabel variant="information">
        Coming soon!
      </StructureLabel>}
    </ClickableListItem>
  )
}

export default FareDropdownOption
